import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Button, Link } from '@coursera/cds-core';

import _t from 'i18n!nls/enroll';

export type PropsFromCaller = {
  onMultipleLearningProgramsLinkClick?: () => void;
};

const MultipleLearningProgramsLink = ({ onMultipleLearningProgramsLinkClick }: PropsFromCaller) => {
  const multipleLearningPrograms = (
    <Button
      component={Link}
      onClick={onMultipleLearningProgramsLinkClick}
      style={{
        color: 'inherit',
        textDecoration: 'underline',
        boxShadow: 'none',
        background: 'none',
        border: 'none',
        padding: 0,
      }}
      data-testid="multiple-learning-programs-button-link"
    >
      {_t('multiple learning programs')}
    </Button>
  );
  const message = _t('This course is part of {multipleLearningPrograms} you might be interested in');
  return <FormattedMessage message={message} multipleLearningPrograms={multipleLearningPrograms} />;
};

export default MultipleLearningProgramsLink;
